import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import ProductCard from '../../components/ProductCard';
import {scrollTo} from '../../lib/utils';
import "./Tiles.css";

export default function Tiles (props) {
  const {items, order, toggleProducts, selected, setCompareProp, compareProp} = props;
  const [mounted, setMounted] = useState();
  useEffect(() => {
    if(!mounted){
      setMounted(true);
      scrollTo();
    }
  }, [mounted]);

  return (
    <section className="view tiles">
    {items.map((item, index) =>
      <ProductCard
        key={index}
        data={item}
        setCompareProp={setCompareProp}
        compareProp={compareProp}
        selected={selected.indexOf(item.id) > -1}
        toggle={toggleProducts}
      />
    )}
    </section>
  )
}

Tiles.propTypes = {
  items: PropTypes.array,
  toggleProducts: PropTypes.func,
  selected: PropTypes.array,
  setCompareProp: PropTypes.func,
  compareProp: PropTypes.string,
};
